import React, { useState } from "react"
import { navigate } from "gatsby"
import { Formik, Field, Form as Form2, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { ButtonSlanted } from "../SVGs"

// Encode for Netlify
function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

// Schema for validation
const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/

const Schema = Yup.object().shape({
  first_name: Yup.string()
    .required("Please enter your first name."),
  last_name: Yup.string()
    .required("Please enter your last name."),
    phone_number: Yup.string()
    .required("Please enter your phone number.")
    .matches(phoneRegExp, 'Please enter your phone number in the following format: 555-555-5555'),
  email_address: Yup.string()
    .email("Please enter your email in the following format: example@sample.com")
    .required("Please enter your email address."),
  
})

const Form = ({svg, buttonClass}) =>{
  const [error, setError] = useState(false)
    function handleSubmit(values, setSubmitting, resetForm) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "contact",
          ...values,
        }),
      })
      .then(() => {
        navigate("/thank-you/", {
          state: { submitted: true },
        })
      })
      .catch(() => {
        resetForm()
        setSubmitting(false)
        setError(true)
      })
    }
    return(
      <>
        <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        phone_number: "",
        email_address: "",
        describe_your_case: "",
      }}
      validationSchema={Schema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values, setSubmitting, resetForm)
      }}
    >
        {({ isSubmitting }) => (
          <Form2
          method="post"
          name="contact"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="contact" />
          <div className="formFieldsGridContainer">
          <Field type="text" name="first_name" placeholder="First Name" required />
          <div className="error">
                 <ErrorMessage name="first_name" />
               </div>
          <Field type="text" name="last_name" placeholder="Last Name" required />
          <div className="error">
                 <ErrorMessage name="last_name" />
               </div>
               <Field type="email" name="email_address" placeholder="Email" required />
               <div className="error">
                 <ErrorMessage name="email_address" />
               </div>
               <Field type="tel" name="phone_number" placeholder="Phone" required />
               <div className="error">
                 <ErrorMessage name="phone_number" />
               </div>
               <Field name="describe_your_case" component="textarea" rows="5" placeholder="Describe Your Case" />
               </div>
               <button type="submit" className={buttonClass} disabled={isSubmitting}>
               {svg !==false &&
               <ButtonSlanted />
               }
                 <p>Submit Your Case</p>
          </button>
          {error && (
            <div classname="submitError">Something went wrong. Please try again!</div>
          )}
          </Form2>
        )}
        </Formik>
        </>
    )
}

export default Form